export default __webpack_public_path__ + "static/media/logo-light-blue.800a2aac.png";